/**
 * A titled settings card with an optional aside (status chip, buttons).
 * Lifted out of TicketAlertsPage so the Integrations grid could use the
 * same one instead of a third copy.
 */
export default function Card({ id, icon: Icon, title, description, children, aside }) {
  return (
    <div id={id} className="scroll-mt-20 rounded-lg border border-neutral-200 bg-white dark:border-neutral-700 dark:bg-neutral-800">
      <div className="flex items-start justify-between gap-4 border-b border-neutral-200 px-6 py-4 dark:border-neutral-700">
        <div>
          <div className="flex items-center gap-2">
            {Icon && <Icon className="h-5 w-5 text-neutral-400" />}
            <h2 className="text-lg font-semibold text-neutral-900 dark:text-white">{title}</h2>
          </div>
          {description && <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">{description}</p>}
        </div>
        {aside}
      </div>
      <div className="p-6">{children}</div>
    </div>
  );
}
